import React from 'react';

import { MenuItem } from '@mui/material';

import { useBaseWidget } from 'hooks/useBaseWidget';

import { ExportDropdown } from 'components/common/ExportDropdown/exportDropdown';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { LineChart } from 'components/common/charts/lineChart/lineChart';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/CommonComponents/CriticalAnalysisIntensity/criticalAnalysisIntensity.module.scss';
import { useDistributionGraphLogic } from 'components/widgets/DistributionGraph/DistributionGraph.logic';
import { useDistributionGraphProvider } from 'components/widgets/DistributionGraph/DistributionGraph.provider';
import { QSRAParameters } from 'components/widgets/DistributionGraph/components/QSRAParameters/QSRAParameters';
import { SummaryRow } from 'components/widgets/DistributionGraph/components/SummaryRow/SummaryRow';
import { ExportToCsvButton } from 'components/widgets/RiskRegister/components/ExportToCsvButton/ExportToCsvButton';

const title = 'Distribution Chart';
const id = 'distributionGraph';

export const DistributionGraph = ({
    projectId,
    contractId,
    latestVersionId,
    widgetId,
    setSubTitleForExport,
    activeTab,
}) => {
    // Provider
    const { api } = useDistributionGraphProvider({
        latestVersionId,
    });

    // Widget
    const { subTitle } = useBaseWidget({
        id,
        widgetId,
        projectId,
        contractId,
        latestVersionId,
        title,
        setSubTitleForExport,
    });

    const { logic } = useDistributionGraphLogic({
        api,
    });

    return activeTab === 'chart' ? (
        <WidgetWithTitle
            title={title}
            id={id}
            tooltip={api.getDistributionGraph.data?.info}
            titleComponents={[
                <ExportDropdown key={'export'} title={title} subTitle={subTitle}>
                    <MenuItem>
                        <ExportToCsvButton
                            headers={logic.exportCsv.headers}
                            rows={logic.exportCsv.rows}
                            fileName={logic.exportCsv.fileName}
                        />
                    </MenuItem>
                </ExportDropdown>,
            ]}
            titleFilters={
                <QSRAParameters numOfIterations={logic.numOfIterations} taskVersionLabel={logic.taskVersionLabel} />
            }
        >
            <SummaryRow api={api} />
            <LineChart
                series={logic.series}
                options={logic.options}
                isFetching={api.getDistributionGraph.isFetching}
                className={classes.lineChart}
            />
        </WidgetWithTitle>
    ) : null;
};
